module.exports = __webpack_public_path__ + "static/media/gastronomia3.f76f2b24.jpg";